<template>
    <div class="managingPeople hp100 bbox " v-loading="loading">
        <!-- 卡片视图 -->
        <el-card>
            <!-- 搜索-->
            <el-row :gutter="20" type="flex" justify="space-between">
          <el-form :inline="true" >
            <el-form-item label="下单人手机号:">
        <el-input clearable style="width:130px"  v-model="queryInfo.condition.orderPhone"></el-input>
            </el-form-item>
            <el-form-item label="就餐日期">
                 <el-date-picker
                style="width:216px"
                 value-format="yyyy-MM-dd"
       v-model="dateRange"
         clearable
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
            </el-form-item>
            <el-form-item label="桌台区域:">
                 <el-select value-key="id" clearable :popper-append-to-body="false"
                 style="width:100px" v-model="tableSelect" placeholder="请选择">
                       <el-option
                       v-for="item,index in tableOption" :key="index"
                 :label="item.areaName"
                 :value="item">
                    </el-option>
                 </el-select>
            </el-form-item>
              <el-form-item label="状态:">
          <el-select :popper-append-to-body="false" 
          style="width:85px"  clearable
          v-model="queryInfo.condition.status">
         <el-option
         v-for="item,index in statusList" :key="index"
          :label="item.name"
          :value="item.status">
                    </el-option>
                 </el-select>
            </el-form-item>
            <el-form-item label="订单号:">
    <el-input clearable style="width:140px" v-model="queryInfo.condition.orderNumber"></el-input>
            </el-form-item>
            <el-form-item>
            <el-button @click="search" class="my-btn">查询</el-button>
            </el-form-item>
        </el-form>
           
            </el-row>
            <!-- 用户列表区域 -->
			 <div  >
        <!-- <el-scrollbar style="height: 100%; width: 100%"> -->
          <el-row style="width: 100%">
            <el-table
            v-loading="tableLoaing"
             element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
                    :data="tableData"
                    border
                    fit
                    height="62vh"
                    highlight-current-row
                    style="width: 100%"
                    @sort-change="sortChange"
            >
<el-table-column label="订单号" align="center"  prop="orderNumber"></el-table-column>
<el-table-column label="桌台" align="center"   >
  <template slot-scope="scope">
    <span>{{scope.row.areaName}}{{scope.row.daySeqStr}}</span>
  </template>
</el-table-column>
<el-table-column label="下单人手机号" align="center"  prop="orderPhone" ></el-table-column>
                <el-table-column label="取号时间" align="center">
                <template slot-scope="scope">
                    <span>{{scope.row.takeTime | dataFormat}}</span>
                    </template>    
                    </el-table-column>    
                    <el-table-column label="就餐时间" align="center"  prop="就餐时间" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.dinnerTime |dataFormat}}</span>
                        </template>
                    </el-table-column>
                     <el-table-column label="用餐人数(位)" align="center"  prop="dinnersNum" >
                    </el-table-column>
                    <el-table-column align="center" label="等待时间(分钟)" prop="latency"></el-table-column>
                    <el-table-column label="状态" align="center">
                        <template slot-scope="scope">
     <span style="color:#79AD56;font-weight:600" v-if="scope.row.status==0">待叫号</span>
      <span v-if="scope.row.status==1">已叫号</span>
       <span style="color:#AFB1B5;" v-if="scope.row.status==2">已就餐</span>
      <span style="color:#DA3751" v-if="scope.row.status==3">已取消</span>
       <span style="color:#E66C84;font-weight:600" v-if="scope.row.status==4">已过号</span>
                </template>
                    </el-table-column>
            </el-table>
                            <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo.currPage"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="queryInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
			 </el-row>
       <!-- </el-scrollbar
        > -->
		</div>
            <!-- <div class="footerBox">
  
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo.currPage"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="queryInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </div> -->
        </el-card>
    </div>
</template>

<script>
export default {
  data() {
    return {
      tableLoaing:true,
        statusList:[
            {name:'待叫号',status:'0',},
            {name:'已叫号',status:'1',},
            {name:'已就餐',status:'2',},
            {name:'已取消',status:'3',},
            {name:'已过号',status:'4',},
            ],
            dateRange:null,
            tableSelect:'',
            tableOption:[],
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition:{
        //   id:"",
          merchantCode:localStorage.getItem('merchantCode'),
          orderPhone:'',
          status:'',
          orderNumber:'',
          manage:1
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
    };
  },
  created() {
    this.tableSelectList()
    this.getListData();
    window.addEventListener('resize', this.getHeight)
  },
  mounted() {
    this.loading = false;
  },
  destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    //条件查询
    search(){
     if(this.dateRange!=null){
        this.queryInfo.condition.startDt=this.dateRange[0]
        this.queryInfo.condition.endDt=this.dateRange[1]
     }else{
        this.queryInfo.condition.startDt=null
        this.queryInfo.condition.endDt=null
     }
     if(this.tableSelect!=null && this.tableSelect!=''){
        this.queryInfo.condition.areaCode=this.tableSelect.areaCode
        this.queryInfo.condition.areaName=this.tableSelect.areaName
     }else{
       this.queryInfo.condition.areaCode=null
        this.queryInfo.condition.areaName=null
     }
     console.log(this.queryInfo)
    this.getListData();
    },
    //桌台下拉
    tableSelectList(){
        this.$http.post('/merchantLineCondition/querySelectTableList',{merchantCode:localStorage.getItem('merchantCode')}).then(res=>{
            this.tableOption=res.data.data
        })
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {
    },

     getListData() {
        // 获取列表
        this.tableLoaing=true
      var that = this;
      that.$http.post("/merchantLineRecord/list", that.queryInfo).then(function (response) {
        console.log(response.data.data);
        that.tableLoaing=false
        if (response.data.code == 200) {
          that.total = response.data.data.count;
          that.queryInfo.currPage=response.data.data.currPage
          that.tableData = response.data.data.data;
        }
      });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
  },
};
</script>

<style lang="less" scoped>
    .textblue {
        color: #008eff;
    }
    .managingPeople {
    .el-card {
        // height: calc(100vh - 114px);
        position: relative;
    .el-select > .el-input {
        width: 200px;
    }
    .header-search-box .header-search-input {
        width: 325px;
    }
    input::placeholder {
        font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
        width: 100%;
        font-size: 13px;
        background-color: transparent;
        color: #008eff;
        z-index: 102;
    }
    .footerBox {
        position: absolute;
        width: 100%;
        height: 78px;
        left: 20px;
        right: 20px;
        bottom: 0;
    }
    }
    }
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  // height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}

/deep/ .my-btn{
    background:#F59A23;
    color:#fff;
    margin-left:12px;
    border-radius: 6px;
}
/deep/ .my-btn:active{
    border-color:#F59A23 ;
}
/deep/ input:focusr{
       border-color:#F59A23 ;
}
/deep/ .el-select .el-input__inner:focus{
       border-color:#F59A23 ;
}
/deep/ .el-select-dropdown__item.selected{
       color:#F59A23 ;
}
/deep/ .el-input__inner:focus{
    border-color: #F59A23;
}
// /deep/ .el-input__inner{
//     .el-range__close-icon{
//         display: none;
//     }
// }
</style>

